import { API_BASE_URL } from "../../../config";
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

const API_BASE = `${API_BASE_URL}/seller/api/sub-product-items`;

const EditSubProductItem = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [item, setItem] = useState(state?.subProductItem || { productCode: '', productName: '', description: '', price: 0, active: true });
    const [error, setError] = useState('');

    useEffect(() => {
        if (!state?.subProductItem) {
            const fetchItem = async () => {
                const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).token : null;
                if (!token) {
                    navigate('/login');
                    return;
                }

                try {
                    const response = await fetch(`${API_BASE}/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Accept': 'application/json'
                        },
                    });

                    if (response.ok) {
                        const data = await response.json();
                        setItem(data);
                    } else if (response.status === 404) {
                        setError('Sub-product item not found');
                    } else {
                        setError('Failed to load sub-product item');
                    }
                } catch (error) {
                    setError('Error fetching sub-product item');
                }
            };

            fetchItem();
        }
    }, [id, navigate, state]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).token : null;
        if (!token) return;

        try {
            const response = await fetch(`${API_BASE}/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    productCode: item.productCode,
                    productName: item.productName,
                    description: item.description,
                    price: item.price,
                    active: !!item.active
                }),
            });

            if (response.ok) {
                navigate('/salepriceAndItemManage');
            } else if (response.status === 404) {
                setError('Sub-product item not found');
            } else {
                setError(`Failed to update sub-product item: ${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            setError('Error updating sub-product item');
        }
    };

    return (
        <div>
            <h1>Edit Sub-Product Item</h1>
            <button onClick={() => navigate('/salepriceAndItemManage')} className="backButton">
                กลับ
            </button>
            {error && <p className="error">{error}</p>}
            <form onSubmit={handleSubmit}>
                <label>
                    รหัสสินค้า (Product Code):
                    <input
                        type="text"
                        value={item.productCode}
                        onChange={(e) => setItem({ ...item, productCode: e.target.value })}
                    />
                </label>
                <label>
                    ชื่อสินค้า (Product Name):
                    <input
                        type="text"
                        value={item.productName}
                        onChange={(e) => setItem({ ...item, productName: e.target.value })}
                    />
                </label>
                <label>
                    รายละเอียด (Description):
                    <input
                        type="text"
                        value={item.description}
                        onChange={(e) => setItem({ ...item, description: e.target.value })}
                    />
                </label>
                <label>
                    ราคา (Price):
                    <input
                        type="number"
                        value={item.price}
                        onChange={(e) => setItem({ ...item, price: parseFloat(e.target.value) })}
                    />
                </label>
                <label>
                    สถานะการขาย (Active):
                    <select
                        value={item.active ? 'true' : 'false'}
                        onChange={(e) => setItem({ ...item, active: e.target.value === 'true' })}
                    >
                        <option value="true">ขาย</option>
                        <option value="false">ไม่ขาย</option>
                    </select>
                </label>

                <button type="submit">Save</button>
            </form>
        </div>
    );
};

export default EditSubProductItem;
